import styled from 'styled-components'

export const ContainerCell = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.content || 'flex-end'};
  flex: 1;
  line-height: 1.5 !important;

  font-size: 12px;
  font-variant-numeric: tabular-nums;

  margin: 10px -3px auto auto;
  min-height: 43px;
`
